import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { whiteColor } from 'src/constants';

export const useStyles = makeStyles(() => createStyles({
  button: {
    display: 'flex',
    height: '40px',
    backgroundColor: '#6C59E6!important',
    color: whiteColor,
    padding: '12px',
    fontSize: '13px',
    fontWeight: '500',
    lineHeight: '16px',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: '0 3px 5px 0 rgba(92, 73, 214, 0.32)!important',
      backgroundColor: '#5C49D6!important',
      transition: 'all 120ms ease-out',
    },
    '&:focus': {
      boxShadow: 'none!important',
      backgroundColor: '#4F3FC0!important',
      transform: 'scale(0.98)',
    },
  },
}));
